import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Button, Dropdown, Input } from 'semantic-ui-react';
import i18next from 'i18next';

import { saveBenefit, editEntityField } from '../../../actions';

class BenefitsEditor extends Component {

    handleSubmit = (event) => {
        const { loyaltyProgramId, entity, saveBenefit } = this.props;
        saveBenefit(loyaltyProgramId, entity);
        event.preventDefault();
    }

    render() {
        const { entity, extra, restaurants, editEntityField } = this.props;
        if (!entity) {
            return null;
        }

        const benefit = entity || {};

        const funderOptions = [
            { value: 'RESTAURANTS', text: i18next.t('restaurants') },
            { value: 'LOYALTY_PROGRAM', text: i18next.t('loyaltyProgram.self') } 
        ];
        const benefitTypeOptions = [
            { value: 'PERCENT', text: i18next.t('percentDiscount') },
            { value: 'AMOUNT', text: i18next.t('amount') }
        ];
        const activationOptions = [
            { value: 'GLOBAL', text: i18next.t('loyaltyProgram.globalActivation') },
            // { value: 'MANUAL', text: i18next.t('loyaltyProgram.manualActivation') }, // Add it when it will be supported
            { value: 'VOUCHER', text: i18next.t('loyaltyProgram.voucherActivation') }
        ];
        const restaurantsOptions = restaurants.map(rest => ({
            value: rest.id,
            text: rest.name
        }));

        return (
            <Form onSubmit={this.handleSubmit}>
                
                <Form.Field required>
                    <label>{i18next.t('description')}</label>
                    <Input required
                        placeholder={i18next.t('description')}
                        value={benefit.description}
                        onChange={({ target }) => editEntityField('description', target.value)}
                    />
                </Form.Field>

                {
                    extra && extra.hasIssues ? null :
                    <Form.Field required>
                        <label>{i18next.t('funding')}</label>
                        <Dropdown required
                            fluid
                            selection
                            placeholder={i18next.t('funding')}
                            options={funderOptions}
                            value={benefit.funder}
                            onChange={(e, { value }) => editEntityField('funder', value)}
                        />
                    </Form.Field>
                }
 
                {
                    extra && extra.hasIssues ? null :
                    <Form.Group>
                        <Form.Field width={7} required>
                            <label>{i18next.t('value')}</label>
                            <Input required
                                type="number"
                                min={0}
                                placeholder={i18next.t('value')}
                                value={benefit.type.value}
                                onChange={({ target }) => editEntityField('type', { ...benefit.type, value: Number(target.value) })}
                            />
                        </Form.Field>
                        <Form.Field required>
                            <label>{i18next.t('loyaltyProgram.benefitType')}</label>
                            <Dropdown required
                                selection
                                placeholder={i18next.t('loyaltyProgram.benefitType')}
                                options={benefitTypeOptions}
                                value={benefit.type.financialType}
                                onChange={(e, { value }) => editEntityField('type', { ...benefit.type, financialType: value })}
                            />
                        </Form.Field>
                    </Form.Group>
                }

                {
                    extra && extra.hasIssues ? null :
                    <Form.Field required>
                        <label>{i18next.t('loyaltyProgram.benefitActivation')}</label>
                        <Dropdown required
                            fluid
                            selection
                            placeholder={i18next.t('loyaltyProgram.benefitActivation')}
                            options={activationOptions}
                            value={benefit.activation}
                            onChange={(e, { value }) => editEntityField('activation', value)}
                        />
                    </Form.Field>
                }

                <Form.Field>
                    <label>{i18next.t('loyaltyProgram.validAt')}</label>
                    <Dropdown
                        placeholder={i18next.t('allRestaurants')}
                        fluid
                        selection
                        options={restaurantsOptions}
                        multiple
                        search
                        value={benefit.validAt.restaurants}
                        onChange={(e, { value }) => editEntityField('validAt', { restaurants: value })}
                    />
                </Form.Field>

                <Form.Group>
                    <Button type='submit' primary floated="right">
                        {i18next.t('save')}
                    </Button>
                </Form.Group>

            </Form>
        );
    }
}

BenefitsEditor.propTypes = {
    loyaltyProgramId: PropTypes.any,
    restaurants: PropTypes.array,
    saveBenefit: PropTypes.func,
    editEntityField: PropTypes.func,
    entity: PropTypes.object
    
};

function mapStateToProps(state) {
    const { restaurants } = state.loyaltyApp;
    const { entity, extra } = state.editor;

    return { entity, extra, restaurants };
}

export default connect(mapStateToProps, { saveBenefit, editEntityField })(BenefitsEditor);
